export const messages = {
  zh: {
    app: {
      siteTitle: '爱小说',
      adminTitle: '小说管理后台'
    },
    nav: {
      home: '首页',
      allWorks: '全部作品',
      rank: '排行榜',
      bookshelf: '我的书架',
      recharge: '充值',
      member: '会员'
    },
    top: {
      logoAlt: '爱小说',
      searchPh: '书名、关键字',
      login: '登录',
      register: '注册',
      points: '积分',
      bookshelf: '我的书架',
      logout: '退出'
    },
    mobileTop: {
      logoAlt: '爱小说',
      searchPh: '书名、关键字',
      login: '登录',
      register: '注册',
      userSetup: '账号设置',
      recharge: '积分充值',
      pointsQuota: '余额：{points}',
      bookshelf: '我的书架',
      addToHome: '添加至桌面',
      addToHomeInstalled: '您已从主屏幕打开本站，无需重复添加。',
      addToHomeIosMessage:
        '点击底部分享按钮，选择「添加到主屏幕」，即可将本站添加到桌面。',
      manualGuideText:
        '点击底部「工具箱」或「更多」按钮，选择「添加到主屏幕」，即可将本站添加到桌面。',
      addToHomeOpenInBrowser:
        '当前为应用内网页。请点击右上角菜单，选择「在浏览器中打开」，再使用浏览器的「添加到主屏幕」。',
      addToHomeSuccess: '已添加到桌面',
      member: '会员中心',
      orders: '我的订单',
      logout: '退出'
    },
    home: {
      hotRecommend: '热门推荐',
      fineRecommend: '精品推荐',
      friendLink: '友情链接'
    },
    rank: {
      click: '点击榜单',
      newBooks: '新书榜单',
      latestUpdates: '最新更新',
      updateList: '更新榜单',
      more: '查看更多'
    },
    table: {
      rank: '排名',
      category: '类别',
      bookName: '书名',
      latestChapter: '最新章节',
      updateTime: '更新时间',
      index: '序号',
      wordCount: '字数'
    },
    bookRankPage: {
      sidebarTitle: '排行榜',
      visit: '点击榜',
      newest: '新书榜',
      update: '更新榜'
    },
    pc: {
      homeLoading: '加载中…',
      paymentBackHome: '返回首页',
      feedback: {
        title: '反馈留言',
        placeholder: '请说明情况，并留下联系方式，你可以在个人中心【我的反馈】里查看回复~',
        submit: '提交',
        submitting: '提交中…',
        errEmpty: '反馈内容不能为空！',
        errMinLen: '反馈内容不能少于 10 个字符！',
        success: '提交成功！'
      },
      userSetup: {
        myAvatar: '我的头像',
        myNick: '我的昵称',
        myGender: '我的性别',
        male: '男',
        email: '电子邮箱'
      },
      bookDetail: {
        category: '类别：',
        status: '状态：',
        totalVisit: '总点击：',
        totalWords: '总字数：',
        collapse: '收起',
        expand: '展开',
        clickRead: '点击阅读',
        continueReading: '继续阅读',
        addShelf: '加入书架',
        chapterTitle: '章节目录',
        chapterCount: '({count}章)',
        similar: '同类推荐',
        chaptersMore: '更多'
      },
      chapterListPage: {
        body: '正文({count})'
      },
      register: {
        title: '注册爱小说账号',
        otherLogin: '其他登录方式',
        weibo: '微博登录',
        qq: 'QQ登录',
        wechat: '微信登录'
      }
    },
    bookClass: {
      workChannel: '作品频道：',
      workCategory: '作品分类：',
      latest: '最新：',
      finished: '是否完结：',
      words: '作品字数：',
      updateTime: '更新时间：',
      sort: '排序方式：',
      wordUnitWan: '万',
      wordUnitQian: '千',
      male: '男频',
      female: '女频',
      noLimit: '不限',
      serializing: '连载中',
      completed: '已完结',
      wordsLt30w: '30万字以下',
      words30to50w: '30-50万字',
      words50to100w: '50-100万字',
      wordsGt100w: '100万字以上',
      days3: '三日内',
      days7: '七日内',
      halfMonth: '半月内',
      month1: '一月内',
      sortUpdate: '更新时间',
      sortWordCount: '总字数',
      sortClicks: '点击量'
    },
    pager: {
      prev: '上一页',
      next: '下一页'
    },
    footer: {
      line: 'Copyright © 2012 - 2013 Some Rights Reserved'
    },
    common: {
      back: '返回',
      tip: '提示',
      confirm: '确定',
      cancel: '取消',
      logoutConfirm: '确认退出登录？',
      networkError: '网络异常！',
      serverError: '服务端异常！',
      requestFailed: '请求失败',
      systemBusy: '系统繁忙，请稍后再试'
    },
    consult: {
      fabLabel: '在线咨询',
      title: '在线咨询',
      welcome: '你好，发送消息后客服会尽快回复。',
      placeholder: '请输入要咨询的内容',
      send: '发送',
      collapse: '收起',
      loginToSend: '登录后发送消息',
      rateLimited: '发送过于频繁，请稍后再试',
      sseIdleHint: '连接已断开，发送消息后将重新连接，客服会尽快回复。'
    },
    ageGate: {
      title: '年龄确认',
      body:
        '根据相关法律法规及平台规范，本站部分内容可能不适合未成年人浏览。请确认您已年满 18 周岁（或已达到您所在司法管辖区的成年年龄），再继续访问本站。',
      confirm: '我已年满 18 周岁',
      leave: '我未满 18 周岁'
    },
    loginPage: {
      title: '登录爱小说',
      titleShort: '登录',
      phonePh: '邮箱账号',
      passwordPh: '密码',
      codePh: '验证码',
      codeAlt: '验证码',
      submit: '登录',
      submitting: '登录中…',
      noAccountDesktop: '还没有注册账号？',
      noAccountMobile: '还没有账号？',
      registerNow: '立即注册',
      forgotPassword: '忘记密码？',
      errEmptyPhone: '邮箱不能为空！',
      errPhoneFormat: '请输入有效的邮箱地址。',
      errEmptyPassword: '密码不能为空！',
      errEmptyCode: '验证码不能为空！',
      errCodeFormat: '验证码为4位字母或数字！',
      errLoginFailed: '登录失败'
    },
    read: {
      wordCountLabel: '字数：',
      updatedAtLabel: '更新时间：',
      backToBook: '书页',
      comment: '评论',
      settings: '设置',
      mobileRead: '手机阅读',
      readTheme: '阅读主题：',
      themeWhite: '白色',
      themeGreen: '绿色',
      themePink: '粉色',
      themeYellow: '黄色',
      themeGray: '灰色',
      themeNight: '夜间',
      bodyFont: '正文字体：',
      fontYahei: '雅黑',
      fontSong: '宋体',
      fontKai: '楷书',
      fontSizeLabel: '字体大小：',
      back: '返回',
      catalog: '目录',
      chaptersTitle: '章节目录({count})',
      collapse: '收起',
      vipNeedPoints: '本章为付费章节，需 {price} 积分解锁',
      pointsLeft: '您还剩余 {points} 积分',
      unlocking: '解锁中...',
      unlockWithPoints: '积分解锁',
      autoUnlockSubsequentPaid: '自动使用积分解锁后续付费章节',
      rechargeNow: '立即充值',
      openMember: '开通会员',
      openMemberTip: '（全站付费章节免积分解锁）',
      loading: '加载中...',
      noContent: '（暂无内容）',
      loadFailed: '（加载失败）',
      prev: '上一章',
      next: '下一章',
      firstChapterTip: '已经是第一章了！',
      lastChapterTip: '已经是最后一章了！',
      loginFirst: '请先登录',
      unlockFailedDefault: '解锁失败，积分不足请先充值'
    },
    bookshelfPage: {
      title: '我的书架',
      empty: '书架里还没有书，去书城逛逛吧',
      select: '选择',
      cancelSelect: '取消',
      removeFromShelf: '移出书架',
      removeConfirm: '确定将选中的 {count} 本书移出书架？',
      removeSuccess: '已移出书架',
      selectFirst: '请先勾选要移出的书'
    },
    mobile: {
      book: {
        clickToRead: '点击阅读',
        continueReading: '继续阅读',
        addToShelf: '加入书架',
        inShelf: '已在书架',
        addedToShelf: '已加入书架',
        addShelfFailed: '加入书架失败',
        vipPaid: '收费',
        vipFree: '免费'
      },
      chapterList: {
        category: '类别：',
        serializing: '连载中',
        completed: '已完结'
      },
      register: {
        title: '注册',
        phonePh: '请输入邮箱账号',
        passwordPh: '请输入密码：6-20位字母/数字',
        codePh: '验证码',
        codeAlt: '验证码',
        submitting: '注册中...',
        submit: '注册',
        hasAccount: '已有账号？',
        loginNow: '立即登录',
        errEmptyPassword: '密码不能为空！',
        errEmptyCode: '验证码不能为空！',
        errCodeFormat: '验证码为4位字母或数字！',
        errRegisterFailed: '注册失败'
      },
      forgotPassword: {
        title: '重置密码',
        emailPh: '请输入邮箱账号',
        codePh: '验证码',
        codeAlt: '验证码',
        submit: '重置密码',
        submitting: '提交中...',
        backToLogin: '返回登录',
        successTip: '若该邮箱已注册，将收到重置密码邮件，请查收。',
        errEmptyEmail: '邮箱不能为空！',
        errEmailFormat: '请输入有效的邮箱地址。',
        errEmptyCode: '验证码不能为空！',
        errCodeFormat: '验证码为4位字母或数字！',
        errFailed: '提交失败，请稍后重试'
      },
      resetPassword: {
        title: '设置新密码',
        passwordPh: '请输入新密码：6-20位',
        confirmPh: '请再次输入新密码',
        submit: '确认修改',
        submitting: '提交中...',
        successTip: '密码已重置，请使用新密码登录',
        errEmptyPassword: '密码不能为空！',
        errPasswordLength: '密码长度为6-20位！',
        errConfirmMismatch: '两次输入的密码不一致！',
        errNoToken: '重置链接无效，请重新申请',
        errFailed: '重置失败，链接可能已过期'
      },
      userSetup: {
        nickNotSet: '未设置昵称',
        pointsBalance: '积分余额',
        recharge: '充值',
        pointsRecharge: '积分充值',
        memberCenter: '会员中心',
        vipBadge: 'VIP',
        errAvatarJpgOnly: '必须上传 JPG 格式的图片!',
        errAvatarMax5mb: '图片大小最多 5MB!'
      },
      member: {
        title: '会员套餐',
        validUntil: '会员有效期至：{endTime}',
        lifetime: '永久会员',
        days: '{days}天',
        lifetimeDays: '永久',
        processing: '处理中...',
        buyNow: '立即开通',
        choosePayment: 'PayPay 扫码支付',
        loginFirst: '请先登录',
        createPayFailed: '创建支付失败',
        openSuccess: '开通成功',
        payFailed: '支付失败',
        initPayFailed: '初始化支付失败',
        intro: '本站采用人工核验收款。请扫码付款并在留言中填写订单备注码，提交截图后由客服核验开通。'
      },
      offlinePay: {
        qrUnavailable: '收款码维护中，暂无法下单，请稍后再试',
        amountLabel: '应付金额',
        memoLabel: '备注码（请填入PayPay留言）',
        copy: '复制',
        copied: '已复制',
        copyFailed: '复制失败，请手动复制',
        defaultHint: '请使用 PayPay 扫描二维码付款，并将备注码填写到付款留言中。',
        qrAlt: 'PayPay收款码',
        txnRef: '交易号（可选）',
        txnRefPh: '可填写PayPay交易号便于核对',
        proof: '付款截图',
        proofTip: '最多3张，jpg/png/webp，单张不超过2MB',
        submitProof: '提交凭证',
        submitting: '提交中...',
        submitSuccess: '已提交，请等待核验',
        submitFailed: '提交失败',
        cancel: '取消订单',
        cancelSuccess: '已取消',
        cancelFailed: '取消失败',
        waitVerify: '正在核验中，请耐心等待。您可以先返回，核验通过后会通过在线咨询通知您。',
        memberApproved: '核验通过，会员已开通！',
        pointsApproved: '核验通过，积分已到账！',
        statusOther: '订单状态：{status}',
        restart: '重新下单',
        createFailed: '创建订单失败',
        rejected: '凭证未通过：{reason}，请重新上传',
        back: '返回',
        contentTypePoints: '积分充值',
        contentTypeMember: '会员开通',
        replaceConfirmTitle: '存在进行中的订单',
        replaceConfirmBody: '您有一笔未完成的{type}订单（金额 {amount} {unit}，备注码 {memo}）。取消后才能按当前选择重新下单。',
        replaceConfirmOk: '取消旧订单并继续',
        replaceConfirmCancel: '暂不取消',
        openOrderWaitVerify: '您有一笔订单正在核验中，完成后才能下新单。',
        openOrderRejected: '您有一笔订单凭证未通过（{reason}），请进入原订单重新上传凭证，暂不能另开新单。',
      },
      payOrders: {
        title: '我的订单',
        tabOpen: '进行中',
        tabWaitPay: '待付款',
        tabWaitVerify: '待核验',
        tabDone: '已完成',
        tabClosed: '已关闭',
        colOrderNo: '订单号',
        colType: '类型',
        colAmount: '金额',
        colStatus: '状态',
        colRemark: '驳回原因',
        colTime: '创建时间',
        colAction: '操作',
        memoCode: '备注码',
        typeMember: '会员开通',
        typePoints: '积分充值',
        goHandle: '去处理',
        backToList: '返回订单列表',
        empty: '暂无订单',
        statusWaitPay: '待付款',
        statusWaitVerify: '待核验',
        statusRejected: '已驳回',
        statusApproved: '已通过',
        statusCancelled: '已取消',
        statusExpired: '已过期',
        statusOther: '状态：{status}',
        prevPage: '上一页',
        nextPage: '下一页',
        loadMore: '加载更多',
        loading: '加载中…',
        noMore: '没有更多了'
      },
      recharge: {
        title: '积分充值',
        currentPoints: '当前积分：{points}',
        amount: '金额',
        amountPh: '请输入充值金额',
        currency: '币种',
        currencyJPY: '日元',
        currencyCNY: '人民币',
        tip: '1元=100积分，最低充值 {min} {unit}',
        processing: '处理中...',
        submit: '立即充值',
        choosePayment: 'PayPay 扫码支付',
        loginFirst: '请先登录',
        invalidAmount: '请输入有效金额',
        minAmountTip: '充值金额不能低于最低限额 {min} {unit}',
        createPayFailed: '创建支付失败',
        rechargeSuccess: '充值成功',
        payFailed: '支付失败',
        initPayFailed: '初始化支付失败'
      },
      paymentResult: {
        successTitle: '支付成功',
        title: '支付结果',
        orderNo: '订单号：{no}',
        intentId: '支付单号：{id}',
        checking: '正在确认支付结果…',
        statusSuccess: '支付状态：已成功',
        statusPending: '支付状态：处理中（异步确认中，请稍后刷新）',
        statusFailed: '支付状态：失败',
        back: '返回',
        backStore: '返回书城'
      },
      bookClass: {
        toggleFilter: '折叠筛选'
      }
    }
  },
  ja: {
    app: {
      siteTitle: '愛小説'
    },
    nav: {
      home: 'ホーム',
      allWorks: '全作品',
      rank: 'ランキング',
      bookshelf: '本棚',
      recharge: 'チャージ',
      member: '会員'
    },
    top: {
      logoAlt: '愛小説',
      searchPh: '書名・キーワード',
      login: 'ログイン',
      register: '新規登録',
      points: 'ポイント',
      bookshelf: 'マイ本棚',
      logout: 'ログアウト'
    },
    mobileTop: {
      logoAlt: '愛小説',
      searchPh: '書名・キーワード',
      login: 'ログイン',
      register: '新規登録',
      userSetup: 'アカウント設定',
      recharge: 'ポイントチャージ',
      pointsQuota: '残高：{points}',
      bookshelf: 'マイ本棚',
      addToHome: 'ホーム画面に追加',
      addToHomeInstalled:
        'すでにホーム画面から本サイトを開いています。追加の操作は不要です。',
      addToHomeIosMessage:
        '画面下部の共有ボタンをタップし、「ホーム画面に追加」を選んでください。',
      manualGuideText:
        '画面下部の「ツールボックス」または「その他」ボタンをタップし、「ホーム画面に追加」を選ぶと、本サイトをホーム画面に追加できます。',
      addToHomeOpenInBrowser:
        'アプリ内ブラウザで開いています。右上のメニューから「ブラウザで開く」を選び、続けてブラウザの「ホーム画面に追加」をご利用ください。',
      addToHomeSuccess: 'ホーム画面に追加しました',
      member: '会員センター',
      orders: '注文履歴',
      logout: 'ログアウト'
    },
    home: {
      hotRecommend: 'おすすめ',
      fineRecommend: '厳選おすすめ',
      friendLink: '友情リンク'
    },
    rank: {
      click: 'クリックランキング',
      newBooks: '新刊ランキング',
      latestUpdates: '最新更新',
      updateList: '更新ランキング',
      more: 'もっと見る'
    },
    table: {
      rank: '順位',
      category: 'ジャンル',
      bookName: '書名',
      latestChapter: '最新話',
      updateTime: '更新日時',
      index: '番号',
      wordCount: '文字数'
    },
    bookRankPage: {
      sidebarTitle: 'ランキング',
      visit: 'クリック',
      newest: '新刊',
      update: '更新'
    },
    pc: {
      homeLoading: '読み込み中…',
      paymentBackHome: 'ホームへ',
      feedback: {
        title: 'ご意見・お問い合わせ',
        placeholder: '内容と連絡先をご記入ください。マイページの「フィードバック」で返信を確認できます。',
        submit: '送信',
        submitting: '送信中…',
        errEmpty: '内容を入力してください。',
        errMinLen: '10文字以上で入力してください。',
        success: '送信しました。'
      },
      userSetup: {
        myAvatar: 'プロフィール画像',
        myNick: 'ニックネーム',
        myGender: '性別',
        male: '男性',
        email: 'メール'
      },
      bookDetail: {
        category: 'ジャンル：',
        status: '状態：',
        totalVisit: 'クリック数：',
        totalWords: '文字数：',
        collapse: '閉じる',
        expand: '開く',
        clickRead: '読む',
        continueReading: '続きを読む',
        addShelf: '本棚に追加',
        chapterTitle: '章一覧',
        chapterCount: '（全{count}話）',
        similar: 'おすすめ',
        chaptersMore: 'もっと見る'
      },
      chapterListPage: {
        body: '本文（{count}）'
      },
      register: {
        title: '愛小説アカウント登録',
        otherLogin: 'その他のログイン',
        weibo: 'Weibo',
        qq: 'QQ',
        wechat: 'WeChat'
      }
    },
    bookClass: {
      workChannel: '作品チャンネル：',
      workCategory: 'ジャンル：',
      latest: '最新：',
      finished: '完結状況：',
      words: '文字数：',
      updateTime: '更新時期：',
      sort: '並び順：',
      wordUnitWan: '万',
      wordUnitQian: '千',
      male: '男性向け',
      female: '女性向け',
      noLimit: '指定なし',
      serializing: '連載中',
      completed: '完結',
      wordsLt30w: '30万字未満',
      words30to50w: '30～50万字',
      words50to100w: '50～100万字',
      wordsGt100w: '100万字超',
      days3: '3日以内',
      days7: '7日以内',
      halfMonth: '半月以内',
      month1: '1か月以内',
      sortUpdate: '更新日時',
      sortWordCount: '総文字数',
      sortClicks: 'クリック数'
    },
    pager: {
      prev: '前へ',
      next: '次へ'
    },
    footer: {
      line: 'Copyright © 2012 - 2013 Some Rights Reserved'
    },
    common: {
      back: '戻る',
      tip: '確認',
      confirm: '確定',
      cancel: 'キャンセル',
      logoutConfirm: 'ログアウトしますか？',
      networkError: 'ネットワークエラーです！',
      serverError: 'サーバーエラーです！',
      requestFailed: 'リクエストに失敗しました',
      systemBusy: 'システムが混雑しています。しばらくしてからお試しください'
    },
    consult: {
      fabLabel: 'オンライン相談',
      title: 'オンライン相談',
      welcome: 'メッセージを送ると、サポートが順次返信します。',
      placeholder: '相談内容を入力してください',
      send: '送信',
      collapse: '閉じる',
      loginToSend: 'ログインして送信',
      rateLimited: '送信が多すぎます。しばらくしてからお試しください',
      sseIdleHint: '接続が切れました。送信すると再接続し、サポートが順次返信します。'
    },
    ageGate: {
      title: '年齢確認',
      body:
        '法令および当サイトの利用規約に基づき、一部コンテンツは18歳未満の方には適さない場合があります。18歳以上であること（またはお住まいの地域で定められた成人年齢に達していること）をご確認のうえ、ご利用ください。',
      confirm: '18歳以上です',
      leave: '18歳未満です'
    },
    loginPage: {
      title: '愛小説にログイン',
      titleShort: 'ログイン',
      phonePh: 'メールアドレス',
      passwordPh: 'パスワード',
      codePh: '認証コード',
      codeAlt: '認証コード',
      submit: 'ログイン',
      submitting: 'ログイン中…',
      noAccountDesktop: 'アカウントをお持ちでないですか？',
      noAccountMobile: 'アカウントをお持ちでないですか？',
      registerNow: '新規登録',
      forgotPassword: 'パスワードをお忘れですか？',
      errEmptyPhone: 'メールアドレスを入力してください。',
      errPhoneFormat: '有効なメールアドレスを入力してください。',
      errEmptyPassword: 'パスワードを入力してください。',
      errEmptyCode: '認証コードを入力してください。',
      errCodeFormat: '認証コードは4桁の英数字です。',
      errLoginFailed: 'ログインに失敗しました。'
    },
    read: {
      wordCountLabel: '文字数：',
      updatedAtLabel: '更新日時：',
      backToBook: '作品ページ',
      comment: 'コメント',
      settings: '設定',
      mobileRead: 'スマホで読む',
      readTheme: 'テーマ：',
      themeWhite: '白',
      themeGreen: '緑',
      themePink: 'ピンク',
      themeYellow: '黄',
      themeGray: '灰',
      themeNight: 'ナイト',
      bodyFont: 'フォント：',
      fontYahei: 'ヤヘイ',
      fontSong: '明朝',
      fontKai: '楷書',
      fontSizeLabel: '文字サイズ：',
      back: '戻る',
      catalog: '目次',
      chaptersTitle: '章一覧({count})',
      collapse: '閉じる',
      vipNeedPoints: 'この章は有料です。{price}ポイントで解放できます',
      pointsLeft: '残りポイント: {points}',
      unlocking: '解放中...',
      unlockWithPoints: 'ポイントで解放',
      autoUnlockSubsequentPaid: '以降の有料章を自動でポイント解放する',
      rechargeNow: '今すぐチャージ',
      openMember: '会員登録',
      openMemberTip: '（全サイトの有料章をポイント不要で読む）',
      loading: '読み込み中...',
      noContent: '（内容がありません）',
      loadFailed: '（読み込みに失敗しました）',
      prev: '前の章',
      next: '次の章',
      firstChapterTip: '最初の章です！',
      lastChapterTip: '最後の章です！',
      loginFirst: '先にログインしてください',
      unlockFailedDefault: '解放に失敗しました。ポイント不足の場合は先にチャージしてください'
    },
    bookshelfPage: {
      title: 'マイ本棚',
      empty: '本棚に作品がありません',
      select: '選択',
      cancelSelect: 'キャンセル',
      removeFromShelf: '本棚から削除',
      removeConfirm: '選択した {count} 件を本棚から削除しますか？',
      removeSuccess: '本棚から削除しました',
      selectFirst: '削除する作品を選択してください'
    },
    mobile: {
      book: {
        clickToRead: '読む',
        continueReading: '続きを読む',
        addToShelf: '本棚に追加',
        inShelf: '本棚に追加済み',
        addedToShelf: '本棚に追加しました',
        addShelfFailed: '本棚への追加に失敗しました',
        vipPaid: '有料',
        vipFree: '無料'
      },
      chapterList: {
        category: 'ジャンル：',
        serializing: '連載中',
        completed: '完結'
      },
      register: {
        title: '新規登録',
        phonePh: 'メールアドレスを入力してください',
        passwordPh: 'パスワード（6〜20文字の英数字）',
        codePh: '認証コード',
        codeAlt: '認証コード',
        submitting: '登録中…',
        submit: '登録',
        hasAccount: 'アカウントをお持ちですか？',
        loginNow: 'ログイン',
        errEmptyPassword: 'パスワードを入力してください。',
        errEmptyCode: '認証コードを入力してください。',
        errCodeFormat: '認証コードは4桁の英数字です。',
        errRegisterFailed: '登録に失敗しました。'
      },
      forgotPassword: {
        title: 'パスワード再設定',
        emailPh: 'メールアドレスを入力してください',
        codePh: '認証コード',
        codeAlt: '認証コード',
        submit: 'パスワードを再設定',
        submitting: '送信中…',
        backToLogin: 'ログインに戻る',
        successTip: '登録済みのメールアドレスであれば、再設定用メールが届きます。',
        errEmptyEmail: 'メールアドレスを入力してください。',
        errEmailFormat: '有効なメールアドレスを入力してください。',
        errEmptyCode: '認証コードを入力してください。',
        errCodeFormat: '認証コードは4桁の英数字です。',
        errFailed: '送信に失敗しました。しばらくしてから再度お試しください。'
      },
      resetPassword: {
        title: '新しいパスワードを設定',
        passwordPh: '新しいパスワード（6〜20文字）',
        confirmPh: '新しいパスワード（確認）',
        submit: '変更を確定',
        submitting: '送信中…',
        successTip: 'パスワードを再設定しました。新しいパスワードでログインしてください。',
        errEmptyPassword: 'パスワードを入力してください。',
        errPasswordLength: 'パスワードは6〜20文字です。',
        errConfirmMismatch: 'パスワードが一致しません。',
        errNoToken: 'リセットリンクが無効です。再度申請してください。',
        errFailed: '再設定に失敗しました。リンクの有効期限が切れている可能性があります。'
      },
      userSetup: {
        nickNotSet: 'ニックネーム未設定',
        pointsBalance: 'ポイント残高',
        recharge: 'チャージ',
        pointsRecharge: 'ポイントチャージ',
        memberCenter: '会員センター',
        vipBadge: 'VIP',
        errAvatarJpgOnly: 'JPG 形式の画像のみアップロードできます。',
        errAvatarMax5mb: '画像サイズは最大 5MB までです。'
      },
      member: {
        title: '会員プラン',
        validUntil: '有効期限：{endTime}',
        lifetime: '永久会員',
        days: '{days}日',
        lifetimeDays: '永久',
        processing: '処理中…',
        buyNow: '今すぐ加入',
        choosePayment: 'PayPayで支払う',
        loginFirst: '先にログインしてください',
        createPayFailed: '決済の作成に失敗しました',
        openSuccess: '加入しました',
        payFailed: '支払いに失敗しました',
        initPayFailed: '決済の初期化に失敗しました',
        intro: '当サイトは手動確認の決済です。QRで支払い、メッセージに注文メモコードを入力し、スクリーンショットを送信してください。'
      },
      offlinePay: {
        qrUnavailable: 'QRコード整備中のため、しばらく注文できません',
        amountLabel: 'お支払い金額',
        memoLabel: 'メモコード（PayPayメッセージに入力）',
        copy: 'コピー',
        copied: 'コピーしました',
        copyFailed: 'コピーに失敗しました',
        defaultHint: 'PayPayでQRをスキャンし、メモコードをメッセージ欄に入力してください。',
        qrAlt: 'PayPayQRコード',
        txnRef: '取引番号（任意）',
        txnRefPh: '照合用の取引番号を入力できます',
        proof: '支払いスクリーンショット',
        proofTip: '最大3枚、jpg/png/webp、各2MBまで',
        submitProof: '証明を送信',
        submitting: '送信中…',
        submitSuccess: '送信しました。確認をお待ちください',
        submitFailed: '送信に失敗しました',
        cancel: '注文を取消',
        cancelSuccess: '取消しました',
        cancelFailed: '取消に失敗しました',
        waitVerify: '確認中です。しばらくお待ちください。先にページをお戻りいただいても構いません。確認が完了したら、オンライン相談でお知らせします。',
        memberApproved: '確認完了。会員が有効になりました！',
        pointsApproved: '確認完了。ポイントが入金されました！',
        statusOther: '注文状態：{status}',
        restart: 'やり直す',
        createFailed: '注文の作成に失敗しました',
        rejected: '証明が却下されました：{reason}。再アップロードしてください',
        back: '戻る',
        contentTypePoints: 'ポイントチャージ',
        contentTypeMember: '会員加入',
        replaceConfirmTitle: '進行中の注文があります',
        replaceConfirmBody: '未完了の{type}注文があります（金額 {amount} {unit}、メモコード {memo}）。取消後に現在の内容で新規注文できます。',
        replaceConfirmOk: '旧注文を取消して続行',
        replaceConfirmCancel: '取消しない',
        openOrderWaitVerify: '確認中の注文があります。完了後に新規注文できます。',
        openOrderRejected: '証明が却下された注文があります（{reason}）。元の注文で再アップロードしてください。新規注文はできません。',
      },
      payOrders: {
        title: '注文履歴',
        tabOpen: '進行中',
        tabWaitPay: '未入金',
        tabWaitVerify: '確認待ち',
        tabDone: '完了',
        tabClosed: '終了',
        colOrderNo: '注文番号',
        colType: '種類',
        colAmount: '金額',
        colStatus: '状態',
        colRemark: '却下理由',
        colTime: '作成日時',
        colAction: '操作',
        memoCode: 'メモコード',
        typeMember: '会員加入',
        typePoints: 'ポイントチャージ',
        goHandle: '処理へ進む',
        backToList: '注文履歴へ戻る',
        empty: '注文はありません',
        statusWaitPay: '未入金',
        statusWaitVerify: '確認待ち',
        statusRejected: '却下',
        statusApproved: '完了',
        statusCancelled: '取消済み',
        statusExpired: '期限切れ',
        statusOther: '状態：{status}',
        prevPage: '前へ',
        nextPage: '次へ',
        loadMore: 'もっと見る',
        loading: '読み込み中…',
        noMore: 'これ以上ありません'
      },
      recharge: {
        title: 'ポイントチャージ',
        currentPoints: '現在のポイント：{points}',
        amount: '金額',
        amountPh: 'チャージ金額を入力',
        currency: '通貨',
        currencyJPY: '円',
        currencyCNY: '人民元',
        tip: '{rate} {unit}=100ポイント，最低チャージ {min}{unit}',
        processing: '処理中…',
        submit: 'チャージする',
        choosePayment: 'PayPayで支払う',
        loginFirst: '先にログインしてください',
        invalidAmount: '有効な金額を入力してください',
        minAmountTip: '最低金額 {min}{unit} 以上で入力してください',
        createPayFailed: '決済の作成に失敗しました',
        rechargeSuccess: 'チャージ完了',
        payFailed: '支払いに失敗しました',
        initPayFailed: '決済の初期化に失敗しました'
      },
      paymentResult: {
        successTitle: '支払い完了',
        title: '支払い結果',
        orderNo: '注文番号：{no}',
        intentId: '決済番号：{id}',
        checking: '支払い結果を確認しています…',
        statusSuccess: '状態：成功',
        statusPending: '状態：処理中（非同期で確認中です。しばらくしてから更新してください）',
        statusFailed: '状態：失敗',
        back: '戻る',
        backStore: '書店へ戻る'
      },
      bookClass: {
        toggleFilter: 'フィルター'
      }
    }
  }
}
